import { useNavigate } from 'react-router-dom'

export default function NotFound() {

  const navigate = useNavigate();
  
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 px-4">
      <div className="text-center">
          <h1 className="text-[40px] font-bold text-red-600">404</h1>
          <p className="text-[15px] text-gray-800 mt-4">Page Not Found</p>
          <p className="text-[15px] text-gray-500 mt-2">Sorry, the page you are looking for doesn't exist.</p>
          <button 
            className="mt-6 inline-block px-6 py-1.5 text-[12px] text-white rounded bg-cbColor transition-all"
            onClick={() => navigate(-1)}
          > 
            Go Back
          </button>
      </div>
    </div>
  )
}
